import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
};

export type Invite = {
  __typename?: 'Invite';
  isMember: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  platformId: Scalars['ID']['output'];
  platformLogoImageUrl?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptPlatformInvite: Platform;
  createPlatform?: Maybe<Platform>;
  createSamplePlatform: Platform;
  deletePlatformUser: Scalars['Boolean']['output'];
  invitePlatformUser: PlatformUser;
  updatePlatformConfiguration?: Maybe<Platform>;
  updatePlatformHaltedStatus?: Maybe<Platform>;
  updatePlatformUserRole: PlatformUser;
  updateUserProfile?: Maybe<User>;
};


export type MutationAcceptPlatformInviteArgs = {
  inviteSecret: Scalars['String']['input'];
  platformUserId: Scalars['ID']['input'];
};


export type MutationCreatePlatformArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationDeletePlatformUserArgs = {
  platformId: Scalars['ID']['input'];
  platformUserId: Scalars['ID']['input'];
};


export type MutationInvitePlatformUserArgs = {
  emailAddress: Scalars['String']['input'];
  platformId: Scalars['ID']['input'];
};


export type MutationUpdatePlatformConfigurationArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enableErrorNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformId: Scalars['ID']['input'];
};


export type MutationUpdatePlatformHaltedStatusArgs = {
  platformId: Scalars['ID']['input'];
  status: PlatformHaltedStatus;
};


export type MutationUpdatePlatformUserRoleArgs = {
  platformId: Scalars['ID']['input'];
  platformUserId: Scalars['ID']['input'];
  role: PlatformUserRole;
};


export type MutationUpdateUserProfileArgs = {
  emailAddress: Scalars['String']['input'];
  name: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type Platform = {
  __typename?: 'Platform';
  activeWaypointTier: WaypointFeatureTier;
  apiHost?: Maybe<Scalars['String']['output']>;
  billingEmailAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enableErrorNotificationEmails: Scalars['Boolean']['output'];
  environment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isHalted: Scalars['Boolean']['output'];
  legacyTemplatesEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  platformUsers: PlatformUserConnection;
  sendingStatus: PlatformSendingStatus;
  updatedAt: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PlatformConnection = {
  __typename?: 'PlatformConnection';
  count: Scalars['Int']['output'];
  nodes: Array<Platform>;
};

export enum PlatformHaltedStatus {
  Active = 'ACTIVE',
  Halted = 'HALTED'
}

export enum PlatformSendingStatus {
  ApprovalNeeded = 'APPROVAL_NEEDED',
  Disabled = 'DISABLED',
  Halted = 'HALTED',
  LiveMode = 'LIVE_MODE',
  Sample = 'SAMPLE',
  SubscriptionNeeded = 'SUBSCRIPTION_NEEDED',
  TestMode = 'TEST_MODE',
  VerificationNeeded = 'VERIFICATION_NEEDED'
}

export type PlatformUser = {
  __typename?: 'PlatformUser';
  deletedAt?: Maybe<Scalars['Date']['output']>;
  displayName: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inviteAcceptedAt?: Maybe<Scalars['Date']['output']>;
  inviteLastSentAt: Scalars['Date']['output'];
  inviteUrl?: Maybe<Scalars['String']['output']>;
  isCurrentUser: Scalars['Boolean']['output'];
  role: PlatformUserRole;
  status: PlatformUserStatus;
};

export type PlatformUserConnection = {
  __typename?: 'PlatformUserConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PlatformUser>;
};

export enum PlatformUserRole {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  User = 'USER'
}

export enum PlatformUserStatus {
  Accepted = 'accepted',
  Invited = 'invited',
  Removed = 'removed'
}

export type Query = {
  __typename?: 'Query';
  Platform: Platform;
  Platforms: PlatformConnection;
  currentPlatformUser: PlatformUser;
  currentUser: User;
  invite?: Maybe<Invite>;
};


export type QueryPlatformArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCurrentPlatformUserArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryInviteArgs = {
  inviteSecret: Scalars['String']['input'];
  platformUserId: Scalars['ID']['input'];
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: UserRole;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export enum UserRole {
  Admin = 'ADMIN',
  User = 'USER'
}

export enum WaypointFeatureTier {
  Free = 'FREE',
  Growth = 'GROWTH',
  Pro = 'PRO',
  Sample = 'SAMPLE',
  Sandbox = 'SANDBOX',
  Starter = 'STARTER',
  Unlimited = 'UNLIMITED'
}

export type FPlatformBillingInformationFragment = { __typename?: 'Platform', billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier };

export type FPlatformFragment = { __typename?: 'Platform', id: string, name: string, createdAt: any, apiHost?: string | null, description?: string | null, environment: string, sendingStatus: PlatformSendingStatus, isHalted: boolean, legacyTemplatesEnabled: boolean, enableErrorNotificationEmails: boolean, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier };

export type FPlatformUserFragment = { __typename?: 'PlatformUser', id: string, displayName: string, status: PlatformUserStatus, inviteLastSentAt: any, inviteAcceptedAt?: any | null, deletedAt?: any | null, emailAddress?: string | null, isCurrentUser: boolean, inviteUrl?: string | null, role: PlatformUserRole };

export type AcceptPlatformInviteMutationVariables = Exact<{
  platformUserId: Scalars['ID']['input'];
  inviteSecret: Scalars['String']['input'];
}>;


export type AcceptPlatformInviteMutation = { __typename?: 'Mutation', acceptPlatformInvite: { __typename?: 'Platform', id: string } };

export type CreatePlatformMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePlatformMutation = { __typename?: 'Mutation', createPlatform?: { __typename?: 'Platform', id: string, name: string, createdAt: any, apiHost?: string | null, description?: string | null, environment: string, sendingStatus: PlatformSendingStatus, isHalted: boolean, legacyTemplatesEnabled: boolean, enableErrorNotificationEmails: boolean, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier } | null };

export type CreateSamplePlatformMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSamplePlatformMutation = { __typename?: 'Mutation', createSamplePlatform: { __typename?: 'Platform', id: string, name: string, createdAt: any, apiHost?: string | null, description?: string | null, environment: string, sendingStatus: PlatformSendingStatus, isHalted: boolean, legacyTemplatesEnabled: boolean, enableErrorNotificationEmails: boolean, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier } };

export type DeletePlatformUserMutationVariables = Exact<{
  platformId: Scalars['ID']['input'];
  platformUserId: Scalars['ID']['input'];
}>;


export type DeletePlatformUserMutation = { __typename?: 'Mutation', deletePlatformUser: boolean };

export type InvitePlatformUserMutationVariables = Exact<{
  platformId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
}>;


export type InvitePlatformUserMutation = { __typename?: 'Mutation', invitePlatformUser: { __typename?: 'PlatformUser', id: string, displayName: string, status: PlatformUserStatus, inviteLastSentAt: any, inviteAcceptedAt?: any | null, deletedAt?: any | null, emailAddress?: string | null, isCurrentUser: boolean, inviteUrl?: string | null, role: PlatformUserRole } };

export type UpdatePlatformConfigurationMutationVariables = Exact<{
  platformId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enableErrorNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePlatformConfigurationMutation = { __typename?: 'Mutation', updatePlatformConfiguration?: { __typename?: 'Platform', id: string, name: string, createdAt: any, apiHost?: string | null, description?: string | null, environment: string, sendingStatus: PlatformSendingStatus, isHalted: boolean, legacyTemplatesEnabled: boolean, enableErrorNotificationEmails: boolean, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier } | null };

export type UpdatePlatformHaltedStatusMutationVariables = Exact<{
  platformId: Scalars['ID']['input'];
  status: PlatformHaltedStatus;
}>;


export type UpdatePlatformHaltedStatusMutation = { __typename?: 'Mutation', updatePlatformHaltedStatus?: { __typename?: 'Platform', id: string, name: string, createdAt: any, apiHost?: string | null, description?: string | null, environment: string, sendingStatus: PlatformSendingStatus, isHalted: boolean, legacyTemplatesEnabled: boolean, enableErrorNotificationEmails: boolean, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier } | null };

export type UpdatePlatformUserRoleMutationVariables = Exact<{
  platformId: Scalars['ID']['input'];
  platformUserId: Scalars['ID']['input'];
  role: PlatformUserRole;
}>;


export type UpdatePlatformUserRoleMutation = { __typename?: 'Mutation', updatePlatformUserRole: { __typename?: 'PlatformUser', id: string, displayName: string, status: PlatformUserStatus, inviteLastSentAt: any, inviteAcceptedAt?: any | null, deletedAt?: any | null, emailAddress?: string | null, isCurrentUser: boolean, inviteUrl?: string | null, role: PlatformUserRole } };

export type UpdateUserProfileMutationVariables = Exact<{
  name: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename?: 'User', id: string, name: string, emailAddress: string, timeZone?: string | null } | null };

export type CurrentPlatformUserQueryVariables = Exact<{
  platformId: Scalars['ID']['input'];
}>;


export type CurrentPlatformUserQuery = { __typename?: 'Query', currentPlatformUser: { __typename?: 'PlatformUser', id: string, displayName: string, status: PlatformUserStatus, inviteLastSentAt: any, inviteAcceptedAt?: any | null, deletedAt?: any | null, emailAddress?: string | null, isCurrentUser: boolean, inviteUrl?: string | null, role: PlatformUserRole } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, emailAddress: string, name: string, timeZone?: string | null, role: UserRole } };

export type InviteQueryVariables = Exact<{
  platformUserId: Scalars['ID']['input'];
  inviteSecret: Scalars['String']['input'];
}>;


export type InviteQuery = { __typename?: 'Query', invite?: { __typename?: 'Invite', platformId: string, platformLogoImageUrl?: string | null, name: string, isMember: boolean } | null };

export type PlatformQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformQuery = { __typename?: 'Query', Platform: { __typename?: 'Platform', id: string, name: string, createdAt: any, apiHost?: string | null, description?: string | null, environment: string, sendingStatus: PlatformSendingStatus, isHalted: boolean, legacyTemplatesEnabled: boolean, enableErrorNotificationEmails: boolean, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier } };

export type PlatformUsersQueryVariables = Exact<{
  platformId: Scalars['ID']['input'];
}>;


export type PlatformUsersQuery = { __typename?: 'Query', Platform: { __typename?: 'Platform', platformUsers: { __typename?: 'PlatformUserConnection', count: number, nodes: Array<{ __typename?: 'PlatformUser', id: string, displayName: string, status: PlatformUserStatus, inviteLastSentAt: any, inviteAcceptedAt?: any | null, deletedAt?: any | null, emailAddress?: string | null, isCurrentUser: boolean, inviteUrl?: string | null, role: PlatformUserRole }> } } };

export type PlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformsQuery = { __typename?: 'Query', Platforms: { __typename?: 'PlatformConnection', count: number, nodes: Array<{ __typename?: 'Platform', id: string, name: string, createdAt: any, apiHost?: string | null, description?: string | null, environment: string, sendingStatus: PlatformSendingStatus, isHalted: boolean, legacyTemplatesEnabled: boolean, enableErrorNotificationEmails: boolean, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier }> } };

export const FPlatformBillingInformationFragmentDoc = gql`
    fragment FPlatformBillingInformation on Platform {
  billingEmailAddress
  activeWaypointTier
}
    `;
export const FPlatformFragmentDoc = gql`
    fragment FPlatform on Platform {
  id
  name
  createdAt
  apiHost
  description
  environment
  sendingStatus
  isHalted
  legacyTemplatesEnabled
  enableErrorNotificationEmails
  ...FPlatformBillingInformation
}
    ${FPlatformBillingInformationFragmentDoc}`;
export const FPlatformUserFragmentDoc = gql`
    fragment FPlatformUser on PlatformUser {
  id
  displayName
  status
  inviteLastSentAt
  inviteAcceptedAt
  deletedAt
  emailAddress
  isCurrentUser
  inviteUrl
  role
}
    `;
export const AcceptPlatformInviteDocument = gql`
    mutation AcceptPlatformInvite($platformUserId: ID!, $inviteSecret: String!) {
  acceptPlatformInvite(
    platformUserId: $platformUserId
    inviteSecret: $inviteSecret
  ) {
    id
  }
}
    `;
export type AcceptPlatformInviteMutationFn = Apollo.MutationFunction<AcceptPlatformInviteMutation, AcceptPlatformInviteMutationVariables>;

/**
 * __useAcceptPlatformInviteMutation_raw__
 *
 * To run a mutation, you first call `useAcceptPlatformInviteMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPlatformInviteMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPlatformInviteMutationRaw, { data, loading, error }] = useAcceptPlatformInviteMutation_raw({
 *   variables: {
 *      platformUserId: // value for 'platformUserId'
 *      inviteSecret: // value for 'inviteSecret'
 *   },
 * });
 */
export function useAcceptPlatformInviteMutation_raw(baseOptions?: Apollo.MutationHookOptions<AcceptPlatformInviteMutation, AcceptPlatformInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPlatformInviteMutation, AcceptPlatformInviteMutationVariables>(AcceptPlatformInviteDocument, options);
      }
export type AcceptPlatformInviteMutation_rawHookResult = ReturnType<typeof useAcceptPlatformInviteMutation_raw>;
export type AcceptPlatformInviteMutationResult = Apollo.MutationResult<AcceptPlatformInviteMutation>;
export type AcceptPlatformInviteMutationOptions = Apollo.BaseMutationOptions<AcceptPlatformInviteMutation, AcceptPlatformInviteMutationVariables>;
export const CreatePlatformDocument = gql`
    mutation CreatePlatform($name: String!, $description: String) {
  createPlatform(name: $name, description: $description) {
    ...FPlatform
  }
}
    ${FPlatformFragmentDoc}`;
export type CreatePlatformMutationFn = Apollo.MutationFunction<CreatePlatformMutation, CreatePlatformMutationVariables>;

/**
 * __useCreatePlatformMutation_raw__
 *
 * To run a mutation, you first call `useCreatePlatformMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlatformMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlatformMutationRaw, { data, loading, error }] = useCreatePlatformMutation_raw({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreatePlatformMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreatePlatformMutation, CreatePlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlatformMutation, CreatePlatformMutationVariables>(CreatePlatformDocument, options);
      }
export type CreatePlatformMutation_rawHookResult = ReturnType<typeof useCreatePlatformMutation_raw>;
export type CreatePlatformMutationResult = Apollo.MutationResult<CreatePlatformMutation>;
export type CreatePlatformMutationOptions = Apollo.BaseMutationOptions<CreatePlatformMutation, CreatePlatformMutationVariables>;
export const CreateSamplePlatformDocument = gql`
    mutation CreateSamplePlatform {
  createSamplePlatform {
    ...FPlatform
  }
}
    ${FPlatformFragmentDoc}`;
export type CreateSamplePlatformMutationFn = Apollo.MutationFunction<CreateSamplePlatformMutation, CreateSamplePlatformMutationVariables>;

/**
 * __useCreateSamplePlatformMutation_raw__
 *
 * To run a mutation, you first call `useCreateSamplePlatformMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSamplePlatformMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSamplePlatformMutationRaw, { data, loading, error }] = useCreateSamplePlatformMutation_raw({
 *   variables: {
 *   },
 * });
 */
export function useCreateSamplePlatformMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateSamplePlatformMutation, CreateSamplePlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSamplePlatformMutation, CreateSamplePlatformMutationVariables>(CreateSamplePlatformDocument, options);
      }
export type CreateSamplePlatformMutation_rawHookResult = ReturnType<typeof useCreateSamplePlatformMutation_raw>;
export type CreateSamplePlatformMutationResult = Apollo.MutationResult<CreateSamplePlatformMutation>;
export type CreateSamplePlatformMutationOptions = Apollo.BaseMutationOptions<CreateSamplePlatformMutation, CreateSamplePlatformMutationVariables>;
export const DeletePlatformUserDocument = gql`
    mutation DeletePlatformUser($platformId: ID!, $platformUserId: ID!) {
  deletePlatformUser(platformId: $platformId, platformUserId: $platformUserId)
}
    `;
export type DeletePlatformUserMutationFn = Apollo.MutationFunction<DeletePlatformUserMutation, DeletePlatformUserMutationVariables>;

/**
 * __useDeletePlatformUserMutation_raw__
 *
 * To run a mutation, you first call `useDeletePlatformUserMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlatformUserMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlatformUserMutationRaw, { data, loading, error }] = useDeletePlatformUserMutation_raw({
 *   variables: {
 *      platformId: // value for 'platformId'
 *      platformUserId: // value for 'platformUserId'
 *   },
 * });
 */
export function useDeletePlatformUserMutation_raw(baseOptions?: Apollo.MutationHookOptions<DeletePlatformUserMutation, DeletePlatformUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlatformUserMutation, DeletePlatformUserMutationVariables>(DeletePlatformUserDocument, options);
      }
export type DeletePlatformUserMutation_rawHookResult = ReturnType<typeof useDeletePlatformUserMutation_raw>;
export type DeletePlatformUserMutationResult = Apollo.MutationResult<DeletePlatformUserMutation>;
export type DeletePlatformUserMutationOptions = Apollo.BaseMutationOptions<DeletePlatformUserMutation, DeletePlatformUserMutationVariables>;
export const InvitePlatformUserDocument = gql`
    mutation InvitePlatformUser($platformId: ID!, $emailAddress: String!) {
  invitePlatformUser(platformId: $platformId, emailAddress: $emailAddress) {
    ...FPlatformUser
  }
}
    ${FPlatformUserFragmentDoc}`;
export type InvitePlatformUserMutationFn = Apollo.MutationFunction<InvitePlatformUserMutation, InvitePlatformUserMutationVariables>;

/**
 * __useInvitePlatformUserMutation_raw__
 *
 * To run a mutation, you first call `useInvitePlatformUserMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitePlatformUserMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitePlatformUserMutationRaw, { data, loading, error }] = useInvitePlatformUserMutation_raw({
 *   variables: {
 *      platformId: // value for 'platformId'
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useInvitePlatformUserMutation_raw(baseOptions?: Apollo.MutationHookOptions<InvitePlatformUserMutation, InvitePlatformUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitePlatformUserMutation, InvitePlatformUserMutationVariables>(InvitePlatformUserDocument, options);
      }
export type InvitePlatformUserMutation_rawHookResult = ReturnType<typeof useInvitePlatformUserMutation_raw>;
export type InvitePlatformUserMutationResult = Apollo.MutationResult<InvitePlatformUserMutation>;
export type InvitePlatformUserMutationOptions = Apollo.BaseMutationOptions<InvitePlatformUserMutation, InvitePlatformUserMutationVariables>;
export const UpdatePlatformConfigurationDocument = gql`
    mutation UpdatePlatformConfiguration($platformId: ID!, $name: String, $description: String, $enableErrorNotificationEmails: Boolean) {
  updatePlatformConfiguration(
    platformId: $platformId
    name: $name
    description: $description
    enableErrorNotificationEmails: $enableErrorNotificationEmails
  ) {
    ...FPlatform
  }
}
    ${FPlatformFragmentDoc}`;
export type UpdatePlatformConfigurationMutationFn = Apollo.MutationFunction<UpdatePlatformConfigurationMutation, UpdatePlatformConfigurationMutationVariables>;

/**
 * __useUpdatePlatformConfigurationMutation_raw__
 *
 * To run a mutation, you first call `useUpdatePlatformConfigurationMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformConfigurationMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformConfigurationMutationRaw, { data, loading, error }] = useUpdatePlatformConfigurationMutation_raw({
 *   variables: {
 *      platformId: // value for 'platformId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      enableErrorNotificationEmails: // value for 'enableErrorNotificationEmails'
 *   },
 * });
 */
export function useUpdatePlatformConfigurationMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformConfigurationMutation, UpdatePlatformConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformConfigurationMutation, UpdatePlatformConfigurationMutationVariables>(UpdatePlatformConfigurationDocument, options);
      }
export type UpdatePlatformConfigurationMutation_rawHookResult = ReturnType<typeof useUpdatePlatformConfigurationMutation_raw>;
export type UpdatePlatformConfigurationMutationResult = Apollo.MutationResult<UpdatePlatformConfigurationMutation>;
export type UpdatePlatformConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformConfigurationMutation, UpdatePlatformConfigurationMutationVariables>;
export const UpdatePlatformHaltedStatusDocument = gql`
    mutation UpdatePlatformHaltedStatus($platformId: ID!, $status: PlatformHaltedStatus!) {
  updatePlatformHaltedStatus(platformId: $platformId, status: $status) {
    ...FPlatform
  }
}
    ${FPlatformFragmentDoc}`;
export type UpdatePlatformHaltedStatusMutationFn = Apollo.MutationFunction<UpdatePlatformHaltedStatusMutation, UpdatePlatformHaltedStatusMutationVariables>;

/**
 * __useUpdatePlatformHaltedStatusMutation_raw__
 *
 * To run a mutation, you first call `useUpdatePlatformHaltedStatusMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformHaltedStatusMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformHaltedStatusMutationRaw, { data, loading, error }] = useUpdatePlatformHaltedStatusMutation_raw({
 *   variables: {
 *      platformId: // value for 'platformId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdatePlatformHaltedStatusMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformHaltedStatusMutation, UpdatePlatformHaltedStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformHaltedStatusMutation, UpdatePlatformHaltedStatusMutationVariables>(UpdatePlatformHaltedStatusDocument, options);
      }
export type UpdatePlatformHaltedStatusMutation_rawHookResult = ReturnType<typeof useUpdatePlatformHaltedStatusMutation_raw>;
export type UpdatePlatformHaltedStatusMutationResult = Apollo.MutationResult<UpdatePlatformHaltedStatusMutation>;
export type UpdatePlatformHaltedStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformHaltedStatusMutation, UpdatePlatformHaltedStatusMutationVariables>;
export const UpdatePlatformUserRoleDocument = gql`
    mutation UpdatePlatformUserRole($platformId: ID!, $platformUserId: ID!, $role: PlatformUserRole!) {
  updatePlatformUserRole(
    platformId: $platformId
    platformUserId: $platformUserId
    role: $role
  ) {
    ...FPlatformUser
  }
}
    ${FPlatformUserFragmentDoc}`;
export type UpdatePlatformUserRoleMutationFn = Apollo.MutationFunction<UpdatePlatformUserRoleMutation, UpdatePlatformUserRoleMutationVariables>;

/**
 * __useUpdatePlatformUserRoleMutation_raw__
 *
 * To run a mutation, you first call `useUpdatePlatformUserRoleMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformUserRoleMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformUserRoleMutationRaw, { data, loading, error }] = useUpdatePlatformUserRoleMutation_raw({
 *   variables: {
 *      platformId: // value for 'platformId'
 *      platformUserId: // value for 'platformUserId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdatePlatformUserRoleMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformUserRoleMutation, UpdatePlatformUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformUserRoleMutation, UpdatePlatformUserRoleMutationVariables>(UpdatePlatformUserRoleDocument, options);
      }
export type UpdatePlatformUserRoleMutation_rawHookResult = ReturnType<typeof useUpdatePlatformUserRoleMutation_raw>;
export type UpdatePlatformUserRoleMutationResult = Apollo.MutationResult<UpdatePlatformUserRoleMutation>;
export type UpdatePlatformUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformUserRoleMutation, UpdatePlatformUserRoleMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($name: String!, $emailAddress: String!, $timeZone: String!) {
  updateUserProfile(name: $name, emailAddress: $emailAddress, timeZone: $timeZone) {
    id
    name
    emailAddress
    timeZone
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation_raw__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutationRaw, { data, loading, error }] = useUpdateUserProfileMutation_raw({
 *   variables: {
 *      name: // value for 'name'
 *      emailAddress: // value for 'emailAddress'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useUpdateUserProfileMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutation_rawHookResult = ReturnType<typeof useUpdateUserProfileMutation_raw>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const CurrentPlatformUserDocument = gql`
    query CurrentPlatformUser($platformId: ID!) {
  currentPlatformUser(platformId: $platformId) {
    ...FPlatformUser
  }
}
    ${FPlatformUserFragmentDoc}`;

/**
 * __useCurrentPlatformUserQuery_raw__
 *
 * To run a query within a React component, call `useCurrentPlatformUserQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPlatformUserQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPlatformUserQuery_raw({
 *   variables: {
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function useCurrentPlatformUserQuery_raw(baseOptions: Apollo.QueryHookOptions<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables> & ({ variables: CurrentPlatformUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables>(CurrentPlatformUserDocument, options);
      }
export function useCurrentPlatformUserLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables>(CurrentPlatformUserDocument, options);
        }
// @ts-ignore
export function useCurrentPlatformUserSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables>;
export function useCurrentPlatformUserSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPlatformUserQuery | undefined, CurrentPlatformUserQueryVariables>;
export function useCurrentPlatformUserSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables>(CurrentPlatformUserDocument, options);
        }
export type CurrentPlatformUserQuery_rawHookResult = ReturnType<typeof useCurrentPlatformUserQuery_raw>;
export type CurrentPlatformUserLazyQuery_rawHookResult = ReturnType<typeof useCurrentPlatformUserLazyQuery_raw>;
export type CurrentPlatformUserSuspenseQuery_rawHookResult = ReturnType<typeof useCurrentPlatformUserSuspenseQuery_raw>;
export type CurrentPlatformUserQueryResult = Apollo.QueryResult<CurrentPlatformUserQuery, CurrentPlatformUserQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    emailAddress
    name
    timeZone
    role
  }
}
    `;

/**
 * __useCurrentUserQuery_raw__
 *
 * To run a query within a React component, call `useCurrentUserQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery_raw(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
// @ts-ignore
export function useCurrentUserSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserQuery | undefined, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQuery_rawHookResult = ReturnType<typeof useCurrentUserQuery_raw>;
export type CurrentUserLazyQuery_rawHookResult = ReturnType<typeof useCurrentUserLazyQuery_raw>;
export type CurrentUserSuspenseQuery_rawHookResult = ReturnType<typeof useCurrentUserSuspenseQuery_raw>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const InviteDocument = gql`
    query Invite($platformUserId: ID!, $inviteSecret: String!) {
  invite(platformUserId: $platformUserId, inviteSecret: $inviteSecret) {
    platformId
    platformLogoImageUrl
    name
    isMember
  }
}
    `;

/**
 * __useInviteQuery_raw__
 *
 * To run a query within a React component, call `useInviteQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useInviteQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQuery_raw({
 *   variables: {
 *      platformUserId: // value for 'platformUserId'
 *      inviteSecret: // value for 'inviteSecret'
 *   },
 * });
 */
export function useInviteQuery_raw(baseOptions: Apollo.QueryHookOptions<InviteQuery, InviteQueryVariables> & ({ variables: InviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
      }
export function useInviteLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<InviteQuery, InviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
        }
// @ts-ignore
export function useInviteSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQuery, InviteQueryVariables>;
export function useInviteSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQuery | undefined, InviteQueryVariables>;
export function useInviteSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
        }
export type InviteQuery_rawHookResult = ReturnType<typeof useInviteQuery_raw>;
export type InviteLazyQuery_rawHookResult = ReturnType<typeof useInviteLazyQuery_raw>;
export type InviteSuspenseQuery_rawHookResult = ReturnType<typeof useInviteSuspenseQuery_raw>;
export type InviteQueryResult = Apollo.QueryResult<InviteQuery, InviteQueryVariables>;
export const PlatformDocument = gql`
    query Platform($id: ID!) {
  Platform(id: $id) {
    ...FPlatform
  }
}
    ${FPlatformFragmentDoc}`;

/**
 * __usePlatformQuery_raw__
 *
 * To run a query within a React component, call `usePlatformQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlatformQuery_raw(baseOptions: Apollo.QueryHookOptions<PlatformQuery, PlatformQueryVariables> & ({ variables: PlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
      }
export function usePlatformLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformQuery, PlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
        }
// @ts-ignore
export function usePlatformSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformQuery, PlatformQueryVariables>;
export function usePlatformSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformQuery | undefined, PlatformQueryVariables>;
export function usePlatformSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
        }
export type PlatformQuery_rawHookResult = ReturnType<typeof usePlatformQuery_raw>;
export type PlatformLazyQuery_rawHookResult = ReturnType<typeof usePlatformLazyQuery_raw>;
export type PlatformSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformSuspenseQuery_raw>;
export type PlatformQueryResult = Apollo.QueryResult<PlatformQuery, PlatformQueryVariables>;
export const PlatformUsersDocument = gql`
    query PlatformUsers($platformId: ID!) {
  Platform(id: $platformId) {
    platformUsers {
      count
      nodes {
        ...FPlatformUser
      }
    }
  }
}
    ${FPlatformUserFragmentDoc}`;

/**
 * __usePlatformUsersQuery_raw__
 *
 * To run a query within a React component, call `usePlatformUsersQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformUsersQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformUsersQuery_raw({
 *   variables: {
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function usePlatformUsersQuery_raw(baseOptions: Apollo.QueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables> & ({ variables: PlatformUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformUsersQuery, PlatformUsersQueryVariables>(PlatformUsersDocument, options);
      }
export function usePlatformUsersLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformUsersQuery, PlatformUsersQueryVariables>(PlatformUsersDocument, options);
        }
// @ts-ignore
export function usePlatformUsersSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformUsersQuery, PlatformUsersQueryVariables>;
export function usePlatformUsersSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformUsersQuery | undefined, PlatformUsersQueryVariables>;
export function usePlatformUsersSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformUsersQuery, PlatformUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformUsersQuery, PlatformUsersQueryVariables>(PlatformUsersDocument, options);
        }
export type PlatformUsersQuery_rawHookResult = ReturnType<typeof usePlatformUsersQuery_raw>;
export type PlatformUsersLazyQuery_rawHookResult = ReturnType<typeof usePlatformUsersLazyQuery_raw>;
export type PlatformUsersSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformUsersSuspenseQuery_raw>;
export type PlatformUsersQueryResult = Apollo.QueryResult<PlatformUsersQuery, PlatformUsersQueryVariables>;
export const PlatformsDocument = gql`
    query Platforms {
  Platforms {
    count
    nodes {
      ...FPlatform
    }
  }
}
    ${FPlatformFragmentDoc}`;

/**
 * __usePlatformsQuery_raw__
 *
 * To run a query within a React component, call `usePlatformsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformsQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function usePlatformsQuery_raw(baseOptions?: Apollo.QueryHookOptions<PlatformsQuery, PlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
      }
export function usePlatformsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
        }
// @ts-ignore
export function usePlatformsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformsQuery, PlatformsQueryVariables>;
export function usePlatformsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformsQuery | undefined, PlatformsQueryVariables>;
export function usePlatformsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
        }
export type PlatformsQuery_rawHookResult = ReturnType<typeof usePlatformsQuery_raw>;
export type PlatformsLazyQuery_rawHookResult = ReturnType<typeof usePlatformsLazyQuery_raw>;
export type PlatformsSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformsSuspenseQuery_raw>;
export type PlatformsQueryResult = Apollo.QueryResult<PlatformsQuery, PlatformsQueryVariables>;
import useApiClient from '@dashboard/hooks/useDashboardClient';

function bindClient<Options, Response>(useApolloHook: (options: Options) => Response) {
  return (options?: Options) => {
    const client = useApiClient();
    return useApolloHook({ client, ...options } as any);
  };
}

export const useAcceptPlatformInviteMutation = bindClient(useAcceptPlatformInviteMutation_raw);
export const useCreatePlatformMutation = bindClient(useCreatePlatformMutation_raw);
export const useCreateSamplePlatformMutation = bindClient(useCreateSamplePlatformMutation_raw);
export const useDeletePlatformUserMutation = bindClient(useDeletePlatformUserMutation_raw);
export const useInvitePlatformUserMutation = bindClient(useInvitePlatformUserMutation_raw);
export const useUpdatePlatformConfigurationMutation = bindClient(useUpdatePlatformConfigurationMutation_raw);
export const useUpdatePlatformHaltedStatusMutation = bindClient(useUpdatePlatformHaltedStatusMutation_raw);
export const useUpdatePlatformUserRoleMutation = bindClient(useUpdatePlatformUserRoleMutation_raw);
export const useUpdateUserProfileMutation = bindClient(useUpdateUserProfileMutation_raw);
export const useCurrentPlatformUserQuery = bindClient(useCurrentPlatformUserQuery_raw);
export const useCurrentUserQuery = bindClient(useCurrentUserQuery_raw);
export const useInviteQuery = bindClient(useInviteQuery_raw);
export const usePlatformQuery = bindClient(usePlatformQuery_raw);
export const usePlatformUsersQuery = bindClient(usePlatformUsersQuery_raw);
export const usePlatformsQuery = bindClient(usePlatformsQuery_raw);
